import React, { useState } from "react";
import { HeaderTabOption } from "./HeaderTabs";
import styles from "./HeaderDropdown.css";
import { Link } from "react-router-dom";
import classNames from "classnames";

interface Props {
  tabs: HeaderTabOption[];
}

export const HeaderDropdown = ({ tabs }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const activeTab: HeaderTabOption = tabs.find((tab) => tab.isActive) ?? tabs[0]!;
  const hasOptions = tabs.filter((tab) => tab.isEnabled).length > 1;
  const isSettingsOpen = tabs.every((tab) => !tab.isActive);
  const shouldShowDropdown = isSettingsOpen || hasOptions;
  return (
    <div className={styles.container}>
      <div className={styles["dropdown-option"]} onClick={() => setIsOpen(!isOpen)}>
        {activeTab.name}
        {shouldShowDropdown && (
          <i
            className={classNames("icon-arrow-up", styles["arrow-icon"], {
              [styles["arrow-inactive"]]: !isOpen
            })}
            onClick={() => setIsOpen(!isOpen)}
          />
        )}
      </div>
      {shouldShowDropdown && isOpen && (
        <div className={styles.list}>
          {tabs
            .filter((tab) => !tab.isActive && tab.isEnabled)
            .map((tab) => (
              <Link
                to={tab.to}
                id={tab.id}
                key={tab.id}
                className={styles["dropdown-option"]}
                onClick={() => setIsOpen(false)}
              >
                <span>{tab.name}</span>
              </Link>
            ))}
        </div>
      )}
    </div>
  );
};
